const titleize = (str: string): string =>
  str.replace(/^(\w)/, (match: string): string => match.toUpperCase());

export default titleize;
